import { Paper } from "@mui/material";
import { BarChart, FormatListNumberedRtl, SportsScore } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.dashboard.achievements.rules", link: "/achievements/rules", icon: <SportsScore /> },
  { text: "pages.dashboard.achievements.levels", link: "/achievements/levels", icon: <FormatListNumberedRtl /> },
  { text: "pages.dashboard.achievements.report", link: "/achievements/report", icon: <BarChart /> },
];

export const AchievementsSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.achievements.title" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
